export default `query getArticles($category_id: ID, $search: String, $pageSize: Int, $currentPage: Int) {
  getArticles(
    input: {
      filter: { category_id: $category_id }
      pageSize: $pageSize
      search: $search
      currentPage: $currentPage
    }
  ) {
    total_count
    items {
      created_at
      id
      image
      image_alt
      slug
      title
      updated_at
      summary {
        html
      }
      category {
        id
        name
        slug
      }
    }
    page_info {
      current_page
      page_size
      total_pages
    }
  }
}
`;
